import Pbf from 'pbf';
import * as P from './proto.tsmap.js';
var TsMap = /** @class */ (function () {
    function TsMap(pbuf) {
        this.pbuf = pbuf;
    }
    TsMap.prototype.times = function () {
        return this.pbuf.Times;
    };
    TsMap.prototype.time2idx = function (time) {
        for (var i = 0; i < this.pbuf.Times.length; i++) {
            if (this.pbuf.Times[i] == time) {
                return i;
            }
        }
        alert('Invalid time ' + time);
        return 0;
    };
    TsMap.prototype.aqis = function (time) {
        var l = this.pbuf.Times.length;
        var concs = this.pbuf.Concentrations;
        var feeds = {};
        var timeIdx = this.time2idx(time);
        this.pbuf.feeds.forEach(function (feed) {
            feeds[feed.name] = {};
            feed.stations.forEach(function (stationIdx) {
                feeds[feed.name][stationIdx] = concs[timeIdx];
                timeIdx += l;
            });
        });
        return feeds;
    };
    return TsMap;
}());
export { TsMap };
export function pbufTsMapDecoder(buffer) {
    var pbf = new Pbf(buffer);
    return P.readTsMap(pbf);
}
